import { createI18n } from 'vue-i18n'

const messages = {
  en: {
    common: {
      confirm: 'Confirm',
      cancel: 'Cancel',
      close: 'Close',
      loading: 'Loading...',
      processing: 'Processing...',
      success: 'Success',
      failed: 'Failed',
      retry: 'Retry',
      copy: 'Copy',
      copied: 'Copied!',
      refresh: 'Refresh',
      viewAll: 'View All',
      noData: 'No data yet',
      submit: 'Submit',
      save: 'Save',
      edit: 'Edit',
      delete: 'Delete',
      search: 'Search',
      query: 'Query',
      comingSoon: 'Coming Soon',
      back: 'Back',
      next: 'Next',
      yes: 'Yes',
      no: 'No',
    },

    nav: {
      home: 'Home',
      dashboard: 'PlayerRound',
      tai: 'Ecosystem',
      prediction: 'Predict',
      nodes: 'Nodes',
      community: 'Community',
      swap: 'Swap',
      admin: 'Admin',
    },
    referrer: {
      title: 'Enter Referrer Address',
      subtitle: 'Please enter your referrer wallet address',
      address: 'Referrer Address',
      placeholder: 'Enter referrer wallet address (0x...)',
      hint: 'Please enter a valid Ethereum address',
      confirm: 'Confirm',
      required: 'Referrer Required',
      description: 'A valid referrer address is required to register',
      errorEmpty: 'Referrer address cannot be empty',
      errorInvalid: 'Invalid address format',
      errorZero: 'Invalid address: cannot be zero address',
    },

    wallet: {
      referrerAddress: 'Referrer Address',
      enterReferrer: 'Enter referrer wallet address',
      referrerRequired: 'Referrer address is required',
      invalidAddress: 'Invalid address format',
      connect: 'Connect Wallet',
      disconnect: 'Disconnect',
      connecting: 'Connecting...',
      connected: 'Connected',
      title: 'Connect Wallet',
      subtitle: 'Choose your Web3 wallet to continue',
      detected: 'Detected · Ready',
      notInstalled: 'Not installed',
      secure: 'Secure & Non-custodial',
      terms: 'By connecting you verify wallet ownership via signature. Your private key is never shared.',
      rejected: 'Connection rejected by user',
      signRequired: 'Please sign the message to verify wallet ownership',
      networkError: 'Please switch to BSC network and try again',
      failed: 'Connection failed, please try again',
      noWallet: 'No wallet detected. Please install a Web3 wallet.',
      installPrompt: 'Install',
      switchNetwork: 'Switch to BSC',
      ready: 'Ready',
    },

    home: {
      tagline: 'Live on BSC',
      heroTitle1: 'User Keep',
      heroTitle2: 'UK Token',
      heroDesc: 'Stake · Predict · Earn · Grow\nPowered by NEXA PAY Global Payment Network',
      connectStart: 'Connect Wallet to Start',
      goDashboard: 'Go to Player Round',
      tradeUK: 'Trade UK',
      currentPrice: 'Current Price',
      priceMultiple: 'Price Multiple',
      totalSupply: 'Total Supply',
      activeNodes: 'Active Nodes',
      feature1Title: 'Prediction Staking',
      feature1Desc: 'Stake 100–1000 USDT with 10x/30x/100x targets. Auto force-sell at target price.',
      feature2Title: 'Community Rewards',
      feature2Desc: 'Build your team and earn V1–V7 community incentives from the reward pool daily.',
      feature3Title: 'Node Privileges',
      feature3Desc: '600 USDT for a node. Get 1000 UK, swap slippage dividends, DAO voting rights.',
    },

    dashboard: {
      withdrawSuccess: "withdraw success",
      insufficientBalance: "insufficient balance",
      max: "max",
      rewardDetails: "Reward Details",
      noRewards: "No reward records yet",
      nodeReward: "Node Rewards",
      nodeRewardDesc: "Released node UK rewards",
      liquidityRewardDesc: "Daily liquidity pool rewards (10%)",
      communityRewardDesc: "Community level rewards (40%)",
      nodeDividendDesc: "Node dividend from prediction mechanism (5%) + Buy Or Sell mechanism (5%)",
      claimed: "Claimed",
      total: "Total",
      view: 'View',
      title: 'PlayerRound',
      execute: 'Execute',
      subtitle: 'Overview of your assets, rewards and withdrawals',
      ukBalance: 'UK Balance',
      ukPrice: 'UK Price',
      myLevel: 'My Level',
      activeStakes: 'My Predictions',
      predictions: 'predictions',
      teamPV: 'Team PV',
      fromInitial: 'from $0.01',
      quickActions: 'Quick Actions',
      predStaking: 'Prediction Staking',
      predDesc: '10x / 30x / 100x targets',
      nodeManage: 'Node Management',
      nodeDesc: '600U · 1000 UK rewards',
      community: 'Community',
      communityDesc: 'V1–V7 level rewards',
      todayRewards: "Today's Rewards",
      noRewards: 'No rewards today yet',
      recentTx: 'Recent Transactions',
      virtualLedger: 'Virtual Ledger',
      // 提现
      withdraw: 'Get UK to Wallet',
      withdrawType: 'Get Type',
      withdrawType1: 'Node UK Release',
      withdrawType2: 'Liquidity Reward',
      withdrawType3: 'Community Reward',
      withdrawType4: 'Node Dividend',
      amount: 'Amount (UK)',
      enterAmount: 'Enter amount',
      minWithdraw: 'Min 100 UK',
      available: 'Available',
      fee: 'Fee (1%)',
      youReceive: 'You receive',
      status: 'Status',
      pendingReview: 'OnChaining',
      requestWithdraw: 'Request Withdraw',
      withdrawSubmitted: 'Withdraw request submitted, pending onchain.',
      withdrawHistory: 'Withdraw History',
      noWithdraws: 'No withdrawal history',
      // 状态标签
      statusPending: 'OnChaining',
      statusApproved: 'Passed',
      statusDone: 'Completed',
      statusRejected: 'Rejected',
      // 奖励汇总
      liquidityReward: 'Liquidity Reward',
      communityReward: 'Community Reward',
      nodeDividend: 'Node Dividend',
      totalRewards: 'Total Rewards',
      pending: 'Pending',
    },

    prediction: {
      saleCountdown: 'Prediction Purchase Countdown',
      saleStartTime: 'Purchase start time: April 25, 2026 20:00 (Beijing time)',
      fromNode: 'From Node',
      fromPrediction: 'From Prediction',
      rangeHint: 'Amount range: 100-1000 USDT',
      soldTime: 'Sold Time',
      soldPrice: 'Sold Price',
      soldUK: 'UK Sold',
      receivedUSDT: 'USDT Received',
      soldTx: 'Sold TX',
      txHash: 'TX Hash',
      approvingUSDT: "Approving USDT",
      joiningOnChain: "Joining On-Chain",
      notifyingBackend: "Complete",
      activeStakers: "Active Stakers",
      participants: "Participants",
      priceTrend: 'UK Price Trend',
      title: 'Prediction',
      subtitle: 'Prediction with price targets. Auto force-sell when target is reached.',
      networkPV: 'Network Pred. Value',
      currentPrice: 'Current Price',
      priceMultiple: 'Price Multiple',
      myPV: 'My Pred. Value',
      newStake: 'New Prediction',
      principal: 'Principal (USDT) · 100–1000',
      enterAmount: 'Enter amount (100–1000 USDT)',
      range: 'Range',
      targetMultiple: 'Target Multiple',
      fundAllocation: 'Fund Allocation Preview',
      liquidityPool: 'Liquidity Pool (40%)',
      incentivePool: 'Incentive Pool (60%)',
      predValue: 'Prediction Value',
      estUKBought: 'Est. UK Bought',
      paymentTx: 'Payment TX Hash',
      txHint: 'Paste the TX hash after sending USDT to the prediction contract',
      stakeBtn: 'Stake ${amount} USDT',
      forceSellNote: 'Force-sell triggers automatically at {multiple}x price target',
      myStakes: 'My Predictions',
      active: 'active',
      noStakes: 'No active stakes yet',
      staking: 'Staking',
      forceSold: 'Force Sold',
      staked: 'Staked',
      stakeSuccess: 'Stake created successfully!',
      conservative: 'Conservative',
      moderate: 'Moderate',
      aggressive: 'Aggressive',
    },

    nodes: {
      saleCountdown: 'Sale Countdown',
      days: 'Days',
      hours: 'Hours', 
      minutes: 'Minutes',
      seconds: 'Seconds',
      saleStartTime: 'Sale starts: March 13, 2026 12:09 (UTC+8)',
      title: 'Node Management',
      subtitle: 'Purchase and manage your network nodes to earn UK token dividends',
      myNodes: 'My Node UK',
      max: 'max',
      totalAlloc: 'Total Allocated',
      totalReleased: 'Total Released',
      claimable: 'Claimable',
      purchaseNode: 'Purchase Node',
      purchaseDesc: 'Become a node holder and earn continuous UK dividend rewards',
      nodePrice: 'Node Price',
      yourUsdtBalance: 'My USDT Balance',
      insufficient: 'Insufficient',
      buyCount: 'Quantity',
      totalCost: 'Total Cost',
      purchaseTx: "Purchase Tx",
      benefit1: 'Participate in UK Token Dividends',
      benefit2: 'Enjoy Maximum Benefits',
      benefit3: 'Receive 60 Prediction Value',
      benefit4: 'Early Adopters Get Lowest UK Price',
      benefit5: 'Generate Exclusive NFT',
      benefit6: 'Long-term Holding Rewards',
      milestone: 'Nodes enjoy maximum benefits and receive 60 prediction value. Early adopters get the lowest UK price.',

      purchaseSuccess: 'Successfully purchased {count} node(s)!',
      purchaseFailed: 'Purchase failed, please try again',
      userCancelled: 'Transaction cancelled by user',
      insufficientUsdt: 'Insufficient USDT balance',
      buyStopped: 'BuyStopped',
      connectFirst: 'Connect Wallet First',
      connectHint: 'Connect your wallet to purchase nodes',
      purchaseBtnLabel: 'Purchase Node ({cost} USDT)',
      txHash: 'Transaction Hash',
      step1: 'Verify',
      step2: 'Approve USDT',
      step3: 'On-chain Confirm',
      step4: 'Sync Data',
      myNodeList: 'My Node List',
      noNodes: 'No Nodes Yet',
      noNodesDesc: 'Purchase a node to view details here',
      active: 'Active',
      inactive: 'Inactive',
      releases: 'releases',
      allocated: 'Allocated',
      released: 'Released',
      onChainNodes: 'On-chain Nodes',
      onChainClaimed: 'On-chain Claimed',
      claimBtn: 'Claim',
      claimFailed: 'Claim failed',
      releaseRules: 'Release Rules',
      rule1Title: 'Monthly Release + Price Acceleration',
      rule1Desc: 'Release 10% every 30 days, or accelerate 10% per 10x price increase, fully released at 100x',
      rule2Title: 'Growing Rewards',
      rule2Desc: 'As platform volume grows, the dividend pool expands and rewards increase',
      rule3Title: 'Instant Claim + NFT',
      rule3Desc: 'Claim anytime after release. Each node generates a unique NFT certificate',

      alreadyNode: 'This address already owns a node',
    },

    community: {
      communityNodes: 'Community Nodes',
      communityNodesDesc: 'Total nodes in your community',
      teamTotalPV: 'Team Total PV',
      todayNewPV: "Today's New PV",
      inviteQR: 'invite QRCode',
      members: 'members',
      title: 'Community',
      subtitle: 'Build your team and earn level-based rewards from the daily incentive pool.',
      myLevel: 'My Level',
      noLevel: 'No Level',
      teamPV: 'Team PV',
      directMembers: 'Direct Members',
      totalTeam: 'Total Team',
      inviteCode: 'My Invite Code',
      copyLink: 'Copy Link',
      levelReqs: 'Level Requirements',
      level: 'Level',
      minTeamPV: 'Min Team PV',
      stake10x: '10x+ Stake',
      estDaily: 'Est. Daily %',
      status: 'Status',
      reached: 'Reached',
      inProgress: 'In Progress',
      queryTeam: 'Query Team Performance',
      queryAddr: 'Enter wallet address to query...',
      address: 'Address',
      totalMembers: 'Total Members',
      myDirectLines: 'My Direct Lines',
      directLines: 'Direct Lines',
      noLines: 'No direct referrals yet',
      subsidyProgress: 'Community Subsidy Progress',
      subsidy20: '20 Nodes Milestone',
      subsidy40: '40 Nodes Milestone',
      apply: 'Apply for Subsidy',
      needMore: 'Need {n} more nodes',
      confirmApply: 'Apply for the {n}-node community subsidy?',
      applySuccess: 'Subsidy application submitted successfully!',
    },

    swap: {
      buyDisabled: 'Buy Disabled',
      buyNotOpen: 'Buy trading not open yet',
      buyNotOpenDesc: 'Buy function is currently disabled. Please wait for official announcement.',
      slippageTooLow: 'Slippage too low, may cause transaction failure',
      slippageTooHigh: 'Slippage too high, please be cautious',
      title: 'Swap',
      subtitle: 'Trade USDT ↔ UK via PancakeSwap V2',
      ukPrice: 'UK Price',
      priceMultiple: 'Price Multiple',
      burned: 'Total Burned',
      circulating: 'Circulating',
      trade: 'Trade',
      buy: 'Buy',
      sell: 'Sell',
      payUsdt: 'You Pay (USDT)',
      payUk: 'You Pay (UK)',
      receiveUk: 'You Receive (UK)',
      receiveUsdt: 'You Receive (USDT)',
      balance: 'Balance',
      autoCalc: 'Auto-calculated',
      estimating: 'Estimating',
      slippage: 'Slippage',
      breakdown: 'Distribution',
      slippageBreakdown: 'Burn 10% · Eco 10% · Foundation 5% · Node 5%',
      buyUK: 'Buy UK',
      sellUK: 'Sell UK',
      connectWallet: 'Connect Wallet',
      walletNote: 'Connect your wallet to execute on-chain swaps via PancakeSwap',
      swapSuccess: 'Swap successful! Transaction confirmed.',
      swapFailed: 'Swap failed, please try again.',
      viewTx: 'View on BscScan',
      tokenInfo: 'Token Info',
      name: 'Name',
      totalSupply: 'Total Supply',
      initialPrice: 'Initial Price',
      targetDestroy: 'Target Destroyed',
      network: 'Network',
      dex: 'DEX',
      contracts: 'Contract Addresses',
      nodeContract: 'Node Contract',
      predContract: 'Prediction Contract',
      slippageDetail: 'Slippage Distribution (30%)',
      burn: 'Burn And Back',
      eco: 'Eco Pool',
      foundation: 'Eco',
      node: 'Node Dividend',
      slippageNote: 'All sells carry 30% slippage. Distribution goes to burn, ecosystem, foundation, and node holders in real-time.',
      livePrice: 'Live Price',
      multiple: 'Multiple',
      pool: 'Pool',
      youPay: 'You Pay',
      youReceive: 'You Receive',
      estimating2: 'Estimating...',
      viaPancake: 'Via PancakeSwap',
      rate: 'Rate',
      route: 'Route',
      minReceived: 'Min Received',
      priceImpact: 'Price Impact',
      connectFirst: 'Connect Wallet First',
      enterAmount: 'Enter Amount',
      processing: 'Processing...',
      txSuccess: '✅ Transaction Successful!',
      powered: 'Powered by PancakeSwap V2 · Decentralized · On-chain',
      poolInfo: 'Liquidity Pool Info',
      ukReserve: 'UK Reserve',
      usdtReserve: 'USDT Reserve',
      pancakePair: 'PancakeSwap Pair',
      priceChart: 'Price Chart (24h)',
      noChartData: 'Insufficient data · More chart data after trading begins',
    },

    txType: {
      prediction_reward: 'Prediction Reward',
      node_release: 'Node UK Release',
      community_reward: 'Community Reward',
      node_dividend: 'Node Dividend',
      whitelist_stake: 'Admin Stake',
      force_sell_return: 'Force Sell Return',
      withdraw_debit: 'Withdraw',
      withdraw_refund: 'Withdraw Refund',
      burn_virtual: 'Virtual Burn',
      swap_virtual: 'Swap',
    },

    error: {
      networkFailed: 'Network request failed',
      tokenExpired: 'Session expired, please reconnect',
      insufficientBalance: 'Insufficient balance',
      minAmount: 'Minimum amount is {min}',
      maxAmount: 'Maximum amount is {max}',
      invalidAddress: 'Invalid wallet address',
      txFailed: 'Transaction failed',
      txRejected: 'Transaction rejected by user',
      unknown: 'Unknown error, please try again',
    },
  },

  // ============================================================
  zh: {
    common: {
      comingSoon: '即将开放',
      confirm: '确认',
      cancel: '取消',
      close: '关闭',
      loading: '加载中...',
      processing: '处理中...',
      success: '成功',
      failed: '失败',
      retry: '重试',
      copy: '复制',
      copied: '已复制！',
      refresh: '刷新',
      viewAll: '查看全部',
      noData: '暂无数据',
      submit: '提交',
      save: '保存',
      edit: '编辑',
      delete: '删除',
      search: '搜索',
      query: '查询',
      back: '返回',
      next: '下一步',
      yes: '是',
      no: '否',
    },

    nav: {
      home: '首页',
      dashboard: '玩家面板',
      tai: '生态',
      prediction: '预测',
      nodes: '节点',
      community: '社区',
      swap: '兑换',
      admin: '管理',
    },
    referrer: {
      title: '输入上级地址',
      subtitle: '请输入您的上级钱包地址',
      address: '上级地址',
      placeholder: '请输入上级钱包地址 (0x...)',
      hint: '请输入有效的以太坊地址',
      confirm: '确认',
      required: '需要上级地址',
      description: '注册需要有效的上级地址',
      errorEmpty: '上级地址不能为空',
      errorInvalid: '地址格式不正确',
      errorZero: '无效地址：不能是零地址',
    },

    wallet: {
      referrerAddress: '上级地址',
      enterReferrer: '请输入上级钱包地址',
      referrerRequired: '请输入上级地址',
      invalidAddress: '地址格式不正确',
      connect: '连接钱包',
      disconnect: '断开连接',
      connecting: '连接中...',
      connected: '已连接',
      title: '连接钱包',
      subtitle: '选择您的 Web3 钱包继续',
      detected: '已检测 · 可连接',
      notInstalled: '未安装',
      secure: '安全 · 非托管',
      terms: '连接钱包即通过签名验证所有权，您的私钥不会被共享。',
      rejected: '用户取消了连接请求',
      signRequired: '请签名以验证钱包所有权',
      networkError: '请切换到 BSC 网络后重试',
      failed: '连接失败，请重试',
      noWallet: '未检测到钱包，请安装 Web3 钱包',
      installPrompt: '安装',
      switchNetwork: '切换到 BSC',
      ready: '就绪',
    },

    home: {
      tagline: 'BSC 链上运行',
      heroTitle1: 'User Keep',
      heroTitle2: 'UK 代币',
      heroDesc: '质押 · 预测 · 赚取 · 成长\n由 NEXA PAY 全球支付网络驱动',
      connectStart: '连接钱包开始',
      goDashboard: '进入玩家面板',
      tradeUK: '交易 UK',
      currentPrice: '当前价格',
      priceMultiple: '价格倍数',
      totalSupply: '总供应量',
      activeNodes: '活跃节点',
      feature1Title: '预测质押',
      feature1Desc: '质押 100–1000 USDT，设定 10x/30x/100x 目标，达到目标价格自动强制卖出。',
      feature2Title: '社区奖励',
      feature2Desc: '建立您的团队，每日从激励池获得 V1–V7 社区奖励。',
      feature3Title: '节点特权',
      feature3Desc: '600 USDT 购买节点，获得 1000 UK、滑点分红、DAO 投票权。',
    },

    dashboard: {
      withdrawSuccess: "提现成功",
      insufficientBalance: "余额不足",
      max: "最大",
      rewardDetails: "奖励明细",
      noRewards: "暂无奖励记录",
      nodeReward: "节点奖励",
      nodeRewardDesc: "节点UK释放奖励",
      liquidityRewardDesc: "每日流动性池奖励 (10%)",
      communityRewardDesc: "社区等级奖励 (40%)",
      nodeDividendDesc: "预测机制节点分红 (5%) + 买卖滑点节点分红 (5%)",
      claimed: "已领取",
      total: "总计",
      view: '查看',
      title: '玩家面板',
      subtitle: '资产、奖励和提现总览',
      ukBalance: 'UK 余额',
      ukPrice: 'UK 价格',
      myLevel: '我的等级',
      activeStakes: '我的预测',
      predictions: '个预测',
      teamPV: '小区预测值',
      fromInitial: '相对 $0.01',
      quickActions: '快速操作',
      predStaking: '预测质押',
      predDesc: '10x / 30x / 100x 目标',
      nodeManage: '节点管理',
      nodeDesc: '600U · 1000 UK 奖励',
      community: '社区',
      communityDesc: 'V1–V7 等级奖励',
      todayRewards: '今日奖励',
      noRewards: '今日暂无奖励',
      recentTx: '近期交易',
      virtualLedger: '虚拟账本',
      withdraw: '领取 UK 到钱包',
      withdrawType: '领取类型',
      withdrawType1: '节点 UK 释放',
      withdrawType2: '流动性奖励',
      withdrawType3: '社区奖励',
      withdrawType4: '节点分红',
      amount: '数量（UK）',
      enterAmount: '输入数量',
      minWithdraw: '最少 100 UK',
      available: '可用',
      execute: '执行',
      fee: '手续费（1%）',
      youReceive: '您将收到',
      status: '状态',
      pendingReview: '链上请求中',
      requestWithdraw: '申请执行',
      withdrawSubmitted: '已提交，等待链上执行',
      withdrawHistory: '提现记录',
      noWithdraws: '暂无提现记录',
      statusPending: '链上请求中',
      statusApproved: '已通过',
      statusDone: '已完成',
      statusRejected: '已拒绝',
      liquidityReward: '流动性奖励',
      communityReward: '社区奖励',
      nodeDividend: '节点分红',
      totalRewards: '总奖励',
      pending: '待领取',
    },

    prediction: {
      saleCountdown: '预测购买倒计时',
      saleStartTime: '购买开始时间：2026年4月25日 21:00 (北京时间)',
      fromNode: '节点贡献',
      fromPrediction: '预测贡献',
      rangeHint: '金额范围：100-1000 USDT',
      soldTime: '卖出时间',
      soldPrice: '卖出价格',
      soldUK: '卖出UK',
      receivedUSDT: '获得USDT',
      soldTx: '卖出交易',
      txHash: '交易哈希',
      approvingUSDT: "授权 USDT",
      joiningOnChain: "链上加入",
      notifyingBackend: "完成",
      activeStakers: "有效预测人数",
      participants: "参与者",
      priceTrend: 'UK价格趋势',
      title: '预测',
      subtitle: '设定价格目标进行预测，达到目标自动强制卖出。',
      networkPV: '全网预测值',
      currentPrice: '当前价格',
      priceMultiple: '价格倍数',
      myPV: '我的预测值',
      newStake: '新建预测',
      principal: '本金（USDT）· 100–1000',
      enterAmount: '输入金额（100–1000 USDT）',
      range: '范围',
      targetMultiple: '目标倍数',
      fundAllocation: '资金分配预览',
      liquidityPool: '流动性池（40%）',
      incentivePool: '激励池（60%）',
      predValue: '预测值',
      estUKBought: '预估购入 UK',
      paymentTx: '付款 TX 哈希',
      txHint: '向预测合约发送 USDT 后，粘贴 TX 哈希',
      stakeBtn: '质押 ${amount} USDT',
      forceSellNote: '达到 {multiple}x 目标价格时自动触发强制卖出',
      myStakes: '我的预测',
      active: '活跃',
      noStakes: '暂无活跃质押',
      staking: '质押中',
      forceSold: '已强制卖出',
      staked: '已质押',
      stakeSuccess: '质押创建成功！',
      conservative: '保守型',
      moderate: '稳健型',
      aggressive: '激进型',
    },

    nodes: {
      saleCountdown: '售卖倒计时',
      days: '天',
      hours: '时',
      minutes: '分',
      seconds: '秒',
      saleStartTime: '售卖开始时间：2026年3月13日 12:09 (北京时间)',
      title: '节点管理',
      subtitle: '购买并管理您的网络节点，参与UK代币分红',
      myNodes: '节点中的UK',
      max: '最多',
      totalAlloc: '总分配UK',
      totalReleased: '已释放UK',
      claimable: '可领取',
      purchaseNode: '购买节点',
      purchaseDesc: '成为节点持有者，获得持续UK分红收益',
      nodePrice: '节点价格',
      yourUsdtBalance: '我的USDT余额',
      insufficient: '余额不足',
      buyCount: '购买数量',
      totalCost: '合计费用',
      benefit1: '参与UK代币分红',
      benefit2: '享受最多权益',
      benefit3: '赠送60预测值',
      benefit4: '早期加入享受UK最低价格',
      benefit5: '生成专属NFT',
      benefit6: '长期持有奖励',
      milestone: '节点享受最多权益,并赠送60预测值,早期加入享受UK最低价格',
      purchaseSuccess: '成功购买 {count} 个节点！',
      purchaseFailed: '购买失败，请重试',
      userCancelled: '用户取消了交易',
      alreadyNode: '该地址已拥有节点',
      insufficientUsdt: 'USDT余额不足，请先充值',
      buyStopped: '停止售卖',
      connectFirst: '请先连接钱包',
      purchaseTx: '购买交易',
      connectHint: '连接钱包后即可购买节点',
      purchaseBtnLabel: '购买节点 ({cost} USDT)',
      txHash: '交易哈希',
      step1: '验证信息',
      step2: '授权USDT',
      step3: '链上确认',
      step4: '同步数据',
      myNodeList: '我的节点列表',
      noNodes: '暂无节点',
      noNodesDesc: '购买节点后即可在此查看详情',
      active: '活跃',
      inactive: '未激活',
      releases: '次释放',
      allocated: '分配',
      released: '已释放',
      onChainNodes: '链上节点数',
      onChainClaimed: '链上已领',
      claimBtn: '领取',
      claimFailed: '领取失败',
      releaseRules: '释放规则',
      rule1Title: '每月释放 + 价格加速',
      rule1Desc: '每30天释放10%,或每上涨10倍提前释放10%,100倍时释放完毕',
      rule2Title: '收益持续增长',
      rule2Desc: '随着平台交易量增长,节点分红池持续扩大,收益逐步提升',
      rule3Title: '即时领取 + NFT',
      rule3Desc: '释放后可随时领取,每个节点生成唯一NFT凭证',

    },

    community: {
      communityNodes: '社区节点数',
      communityNodesDesc: '您的社区内所有节点总数',
      teamTotalPV: '团队总预测值',
      todayNewPV: '今日新增预测值',
      inviteQR: '邀请二维码',
      members: '成员',
      title: '社区',
      subtitle: '建立您的团队，从每日激励池中获得基于等级的奖励。',
      myLevel: '我的社区等级',
      noLevel: '无等级',
      teamPV: '小区预测值',
      directMembers: '直推成员',
      totalTeam: '总团队',
      inviteCode: '我的邀请码',
      copyLink: '复制链接',
      levelReqs: '等级要求',
      level: '等级',
      minTeamPV: '最低小区 PV',
      stake10x: '10x+ 质押',
      estDaily: '预估日收益%',
      status: '状态',
      reached: '已达到',
      inProgress: '进行中',
      queryTeam: '查询团队业绩',
      queryAddr: '输入钱包地址查询...',
      address: '地址',
      totalMembers: '总成员',
      myDirectLines: '我的直推线',
      directLines: '直推线',
      noLines: '暂无直推成员',
      subsidyProgress: '社区补贴进度',
      subsidy20: '20 节点里程碑',
      subsidy40: '40 节点里程碑',
      apply: '申请补贴',
      needMore: '还需 {n} 个节点',
      confirmApply: '申请 {n} 节点社区补贴？',
      applySuccess: '补贴申请提交成功！',
    },

    swap: {
      buyDisabled: '买入已禁用',
      buyNotOpen: '买入交易暂未开放',
      buyNotOpenDesc: '买入功能当前已禁用，请等待官方公告。',
      slippageTooLow: '滑点过低，可能导致交易失败',
      slippageTooHigh: '滑点过高，请谨慎操作',
      title: '兑换',
      subtitle: '通过 PancakeSwap V2 交易 USDT ↔ UK',
      ukPrice: 'UK 价格',
      priceMultiple: '价格倍数',
      burned: '累计销毁',
      circulating: '流通量',
      trade: '交易',
      buy: '买入',
      sell: '卖出',
      payUsdt: '您支付（USDT）',
      payUk: '您支付（UK）',
      receiveUk: '您收到（UK）',
      receiveUsdt: '您收到（USDT）',
      balance: '余额',
      autoCalc: '自动计算',
      estimating: '估算中',
      slippage: '滑点',
      breakdown: '分配',
      slippageBreakdown: '销毁 10% · 生态 10% · 基金会 5% · 节点 5%',
      buyUK: '买入 UK',
      sellUK: '卖出 UK',
      connectWallet: '连接钱包',
      walletNote: '连接钱包以通过 PancakeSwap 执行链上兑换',
      swapSuccess: '兑换成功！交易已确认。',
      swapFailed: '兑换失败，请重试。',
      viewTx: '在 BscScan 查看',
      tokenInfo: '代币信息',
      name: '名称',
      totalSupply: '总供应量',
      initialPrice: '初始价格',
      targetDestroy: '目标销毁量',
      network: '网络',
      dex: '去中心化交易所',
      contracts: '合约地址',
      nodeContract: '节点合约',
      predContract: '预测合约',
      slippageDetail: '滑点分配（30%）',
      burn: '销毁并回流',
      eco: '生态池',
      foundation: '生态建设',
      node: '节点分红',
      slippageNote: '卖含 30% 滑点，实时分配至销毁、生态、基金会和节点持有者。',
      livePrice: '实时价格',
      multiple: '倍数',
      pool: '流动池',
      youPay: '您支付',
      youReceive: '您收到',
      estimating2: '估算中...',
      viaPancake: '通过 PancakeSwap',
      rate: '汇率',
      route: '路由',
      minReceived: '最少收到',
      priceImpact: '价格影响',
      connectFirst: '请先连接钱包',
      enterAmount: '输入金额',
      processing: '处理中...',
      txSuccess: '✅ 交易成功！',
      powered: '由 PancakeSwap V2 驱动 · 去中心化 · 链上',
      poolInfo: '流动性池信息',
      ukReserve: 'UK 储备',
      usdtReserve: 'USDT 储备',
      pancakePair: 'PancakeSwap 交易对',
      priceChart: '价格走势（24h）',
      noChartData: '数据不足 · 交易开始后将显示更多图表数据',
    },

    txType: {
      prediction_reward: '预测奖励',
      node_release: '节点 UK 释放',
      community_reward: '社区奖励',
      node_dividend: '节点分红',
      whitelist_stake: '管理员质押',
      force_sell_return: '强制卖出返还',
      withdraw_debit: '提现',
      withdraw_refund: '提现退款',
      burn_virtual: '虚拟销毁',
      swap_virtual: '兑换',
    },

    error: {
      networkFailed: '网络请求失败',
      tokenExpired: '登录已过期，请重新连接',
      insufficientBalance: '余额不足',
      minAmount: '最少 {min}',
      maxAmount: '最多 {max}',
      invalidAddress: '无效的钱包地址',
      txFailed: '交易失败',
      txRejected: '用户拒绝了交易',
      unknown: '未知错误，请重试',
    },
  }
}

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('lang') || (navigator.language.startsWith('zh') ? 'zh' : 'en'),
  fallbackLocale: 'en',
  messages,
})

export default i18n
